export default __webpack_public_path__ + "static/media/map-icon.ae8e79ed.svg";